export default [
	{
		type: "age",
		id: 1,
		items: [
			{
				id: 1,
				text: "Age: ",
			},
		],
	},
	{
		type: "uni",
		id: 2,
		items: [
			{
				id: 2,
				text: "The learning objective was clear to me.",
			},
			{
				id: 3,
				text: "The educational objectives were well defined from the beginning.",
			},
			{
				id: 4,
				text: "The course was well structured and comprehensible.",
			},
			{
				id: 5,
				text: "The structure of the content was logical/easy to follow.",
			},
			{
				id: 6,
				text: "I was already interested in the subject of the course before I signed up for it.",
			},
			{
				id: 7,
				text: "The topic of the course is relevant.",
			},
			{
				id: 8,
				text: "I believe that I have learned important facts in this course.",
			},
			{
				id: 9,
				text: "The topic of the course is relevant for the work of a pharmacist.",
			},
			{
				id: 10,
				text: "The difficulty of the content was adequate.",
			},
			{
				id: 11,
				text: "The amount of the content was adequate.",
			},
			{
				id: 12,
				text: "The pace of the course was adequate.",
			},
			{
				id: 13,
				text: "The requirements of the course were adequate.",
			},
			{
				id: 14,
				text: "The lecturer is able to add information to oral presentations in a proper way.",
			},
			{
				id: 15,
				text: "The presentation style of oral presentations is appealing.",
			},
			{
				id: 16,
				text: "The content of oral presentations is of high quality.",
			},
			{
				id: 17,
				text: "The oral presentations given by other participants have been very informative.",
			},
			{
				id: 18,
				text: "The preliminary discussion accompanying the event is helpful.",
			},
			{
				id: 19,
				text: "The script is understandable and prepares adequately for the experiments.",
			},
			{
				id: 20,
				text: "The experiments/tasks can be completed in the allotted time.",
			},
			{
				id: 21,
				text: "The experiments worked.",
			},
			{
				id: 22,
				text: "The functionality of the equipment/reagents is adequate and up to date.",
			},
			{
				id: 23,
				text: "The safety briefing is adequate.",
			},
			{
				id: 24,
				text: "The size of the participant group is appropriate.",
			},
			{
				id: 25,
				text: "The instructions for evaluating the experiments are sufficient and clear.",
			},
			{
				id: 26,
				text: "The pharmaceutical relevance of the methods or techniques is clear.",
			},
			{
				id: 27,
				text: "The condition of the internship rooms was appropriate and up-to-date.",
			},
			{
				id: 28,
				text: "The lab supervision provided a pleasant working atmosphere.",
			},
			{
				id: 29,
				text: "The amount of time required for the course (including preparation and follow-up) was appropriate.",
			},
			{
				id: 30,
				text: "The course was too difficult for me.",
			},
			{
				id: 31,
				text: "The recommended literature was available in the library in sufficient quantity.",
			},
			{
				id: 32,
				text: "Overall, this was a good course.",
			},
			{
				id: 33,
				text: "I learned a lot in this course.",
			},
			{
				id: 34,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 35,
				text: "I would recommend the course.",
			},
		],
	},
	{
		type: "text",
		id: 3,
		items: [
			{
				id: 36,
				text: "Further remarks",
			},
		],
	},
	{
		type: "dsp",
		id: 4,
		items: [
			{
				id: 37,
				text: "The lecturer was enthusiastic and motivated.",
			},
			{
				id: 38,
				text: "The lecturer provided a good learning and working atmosphere.",
			},
			{
				id: 39,
				text: "The lecturer has always been well prepared.",
			},
			{
				id: 40,
				text: "The lecturer was able to put complicated ideas across.",
			},
		],
	},
];
